<template>
  <span :class="['order-status', `status-${item}`]">{{ item ? getI18N("orders.statuses.shippingStatuses", item) : "" }}</span>
</template>

<script>
import { normalizeStatusName } from "../../mixins/formats";

export default {
  name: "OrderStatus",
  props: {
    item: {
      type: [String, Number, undefined],
      required: false,
    },
  },
  methods: {
    getCls(statusName) {
      return `status-${normalizeStatusName(statusName)}`;
    },
    getI18N(prefix, statusName) {
      return this.$t(`${prefix}.${normalizeStatusName(statusName)}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.order-status {
  display: inline-block;
  padding: 5.5px 1rem;
  border-radius: 15px;
  line-height: 14px;
}
</style>
